import { api_get, api_post, params_post } from '@/utils/http'
import { QrcodeRequest, StatusRequest } from './qrcode'

const testUri = 'https://www.test.17zuoye.net' // 支付接口 baseUri
const stagingUri = 'https://www.staging.17zuoye.net'
const prodUri = 'https://www.17zuoye.com'
let baseUri = prodUri
if (location.href.includes('17zuoye.com')) {
  baseUri = prodUri
} else if (location.href.includes('17zuoye.net')) {
  baseUri = testUri
}
// 生成二维码接口
function qrcodeAPI(params: QrcodeRequest) {
  return params_post(baseUri + '/v3/order/create.api', params)
}
// 查看订单状态接口(订单中心)
function statusQuery(params: StatusRequest) {
  return api_get(baseUri + '/v3/order/status/query.api', params)
}
// 订单状态查询
function orderQuery(data: { orderId: string; skuId: string }) {
  return api_get('/search/api/pay/roundRobin/callback', data)
}
// 获取会员包列表
function skuList(data: { sku_type: string }) {
  return api_post('/search/api/commodity/sku/list', data)
}
export { qrcodeAPI, statusQuery, orderQuery, skuList }
